import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'
import { bootstrap_session, session } from './store.svelte.js'
import { initMetaPixel } from './lib/tracking/meta-pixel.js'

// Fire-and-forget: the shell renders a bootstrap indicator until session.loaded
// flips, so mounting need not wait on the network.
// Staff browsing the site would skew ad data, so the pixel stays off for them.
// Web entry only: the Telegram Mini App is not an ad landing page.
bootstrap_session().then(() => {
  initMetaPixel(session.is_superuser ? null : session.config.meta_pixel_id, { user: session.user })
})

const target = document.getElementById('app')
const server_content = target.querySelector(':scope > #seo-content')
let client_target = target

// Crawler requests can arrive with semantic HTML rendered by Django. If such
// a client also executes JavaScript, mount Svelte into
// an off-flow sibling and swap both trees in one frame once the client route
// has committed, rather than clearing #app first (which erased the only useful
// first paint) or mounting in normal flow (which duplicates the page).
// The crawler tree holds the layout box while the hidden client tree commits.
// Normal browsers never enter this branch because Django leaves their #app
// mount empty.
if (server_content) {
  target.dataset.handoff = ''
  client_target = document.createElement('div')
  client_target.dataset.clientRoot = ''
  client_target.setAttribute('aria-hidden', 'true')
  target.append(client_target)

  let swapped = false
  const swap = () => {
    if (swapped) return
    swapped = true
    document.removeEventListener('visibilitychange', on_visibility)
    server_content.remove()
    client_target.removeAttribute('aria-hidden')
    target.removeAttribute('data-handoff')
  }

  // A document that is not being rendered gets no animation frames, so the
  // two-frame swap below never runs there and the page stays on the server
  // tree with the real app hidden behind it — permanently, for anything
  // opened in a background tab or restored with the session. Nothing is
  // painting in that state, so there is no frame to wait for: swap at once.
  const on_visibility = () => {
    if (document.hidden) swap()
  }

  const observer = new MutationObserver(() => {
    if (!client_target.querySelector('[data-app-ready]')) return
    observer.disconnect()
    if (document.hidden) return swap()
    document.addEventListener('visibilitychange', on_visibility)
    requestAnimationFrame(() => requestAnimationFrame(swap))
  })
  observer.observe(client_target, { childList: true, subtree: true })
}

const app = mount(App, {
  target: client_target,
})

export default app
